// TODO: thoughts for the future (see in CategoryPage)
export default {
  phone: 'phone',
  tabPort: 'tab-port',
  tabLand: 'tab-land',
  bigDesktop: 'big-desktop',
};
